export default {
  artistName: 'SANDRA DISCHNER',
  tagline: 'Contemporary Art & Design',
  scrollIndicator: 'Scroll to explore',
  all_rights: 'All rights reserved.',
  back: '← Back',
  featuredWorks: 'Featured Works',
  collectionDescription: 'A collection of contemporary pieces',
  visualJourney: 'Visual Journey',
  contemporaryExpression: 'Contemporary Expression',
  artisticEvolution: 'Artistic Evolution',
  fromRegensburg: 'FROM REGENSBURG',
  withLoveToWorld: 'WITH ♥ TO THE WORLD',
  continueScrolling: 'Continue scrolling',
  impressum: 'Impressum',
  artistInfo: 'Artist Information',
  websiteInfo: 'Website Information',
  responsibleContent: 'Responsible for Content',
  odrHeading: 'Online Dispute Resolution pursuant to Article 14 (1) ODR Regulation',
  odrText: 'The European Commission provides a platform for online dispute resolution (ODR), which you can find at the following link',
  vsbgHeading: 'Notice pursuant to § 36 of the German Consumer Dispute Resolution Act (VSBG)',
  vsbgText: 'We are neither obliged nor willing to participate in dispute resolution proceedings before a consumer arbitration board.',
  copyrightHeading: 'Copyright',
  copyrightText: 'The content and works provided on this website are governed by the copyright laws of the applicable jurisdiction. Any duplication, processing, distribution, or any form of utilization beyond the scope of copyright law will require the prior written consent of the author or rightsholder.',
  countryGermany: 'Germany',
  stateBayern: 'Bavaria'
};
